import React from 'react';
import { CheckIcon } from 'lucide-react';
import { forYouPoints } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function ForYou() {
  return <section className="w-full bg-ink-950 px-4 py-14 sm:py-20" data-id="element-117" data-mp="323vxb24zgpxv">
      <div className="mx-auto max-w-2xl" data-id="element-118" data-mp="2oc7r1fhf0vot">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.25em] text-spark-500" data-id="element-119" data-mp="2t9r4wea7b6g8">
          Est-ce fait pour vous ?
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-120" data-mp="3gztsah367o8i">
          Le Système Maître a été créé pour vous si…
        </h2>

        <ul className="mt-8 space-y-2.5" data-id="element-121" data-mp="370mddpgsflja">
          {forYouPoints.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/10 bg-ink-800/60 px-4 py-3.5" data-id="element-122" data-mp="3byxos4mqe43m">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-arc-500/20" data-id="element-123" data-mp="20ksktbmipu8a">
                <CheckIcon className="h-3 w-3 text-arc-400" aria-hidden="true" data-id="element-124" data-mp="3p8seh5cm3kjz" />
              </span>
              <span className="text-[15px] leading-snug text-white/80" data-id="element-125" data-mp="3l8qnbq4i69iy">{item}</span>
            </li>)}
        </ul>

        <p className="mt-6 text-balance text-center text-base font-bold text-spark-400" data-id="element-126" data-mp="33x4bhwgnkiy">
          Si vous vous reconnaissez dans l’un de ces points, ce système est fait pour vous.
        </p>

        <div className="mt-9" data-id="element-127" data-mp="c1phafepmg36">
          <CtaBlock label="Oui, c’est fait pour moi" data-id="element-128" data-mp="c0nwhj7w6f89" />
        </div>
      </div>
    </section>;
}